import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Checkbox24 from 'icons/Checkbox24';
import Checkbox24Filled from 'icons/Checkbox24Filled';

import classNames from 'utils/classNames';

import styles from './checkbox.scss';

export default function Checkbox(props) {
    const { defaultChecked } = props;
    const [checked, setChecked] = useState(defaultChecked);

    function handleClick(e) {
        const { onClick } = props;

        if (e.target && e.target.nodeName === 'A') return;

        if (typeof onClick === 'function') {
            onClick(e);
        } else {
            setChecked(!checked);
        }
    }

    useEffect(() => {
        const { onCheck } = props;

        if (typeof onCheck === 'function') {
            onCheck(checked);
        }
    }, [checked]);

    const wrapperClasses = classNames(styles.wrapper, {
        [styles.checked]: checked,
    });

    return (
        <div className={wrapperClasses} onClick={handleClick}>
            <div className={styles.content}>
                <div className={styles.icon}>{checked ? <Checkbox24Filled /> : <Checkbox24 />}</div>
                <div className={styles.label}>
                    <span>{props.children}</span>
                </div>
            </div>
        </div>
    );
}

Checkbox.propTypes = {
    /**
     * Triggers on element click and returns the current state of the checkbox.
     * @returns {boolean} Checkbox state.
     */
    onCheck: PropTypes.func,
    onClick: PropTypes.func,
    children: PropTypes.node,
    defaultChecked: PropTypes.bool,
};
